import { useIsDarkMode } from '@trello/theme';

import darkImage from './smart-schedule-onboarding-dark.png';
import lightImage from './smart-schedule-onboarding-light.png';

import * as styles from './SmartScheduleOnboardingImage.module.less';

export const SmartScheduleOnboardingImage = () => {
  const isDarkMode = useIsDarkMode();

  return (
    <img
      className={styles.image}
      src={isDarkMode ? darkImage : lightImage}
      alt=""
    />
  );
};
